import React from "react";
import {Icon} from "antd";

const articleSvgList = {
    //预览
    view: (colors) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1351 1024" className="design-iconfont">
            <path d="M675.581823 259.310149a268.681992 268.681992 0 0 1 266.119905 252.500391h409.461917C975.817936-170.581039 375.345709-170.581039 0 511.81054h409.461917a263.760089 263.760089 0 0 1 266.119906-252.500391z m0 505.000783a268.681992 268.681992 0 0 0 266.119905-252.500392h409.461917C975.817936 1194.20212 375.345709 1194.20212 0 511.81054h409.461917a263.760089 263.760089 0 0 0 266.119906 252.500392z"
                  fill={(colors && colors.length && colors[0]) ? colors[0] : "#ccc"}/>
            <path
                d="M539.049568 511.743117a129.655074 129.655074 0 1 0 129.655074-129.655074A129.655074 129.655074 0 0 0 539.049568 511.743117z"
                transform="translate(-54.087 .358)"
                fill={(colors && colors.length && colors[1]) ? colors[1] : "#ccc"}/>
        </svg>
    ),

    //点赞
    like: (colors) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" className="design-iconfont">
            <path
                d="M939.108808 408.53886h-270.590673C774.632124 21.222798 594.238342 0 594.238342 0 514.65285 0 530.569948 58.362694 525.264249 68.974093c0 191.005181-201.61658 339.564767-201.616581 339.564767v541.181347c0 53.056995 74.279793 74.279793 100.808291 74.279793h408.53886c37.139896 0 68.974093-100.80829 68.974093-100.80829 100.80829-344.870466 100.80829-445.678756 100.80829-445.678757 0-31.834197-21.222798-63.668394-58.362694-63.668393 0-5.305699-5.305699-5.305699-5.3057-5.3057z m0 0H47.751295c-15.917098 0-31.834197 15.917098-31.834197 31.834197l31.834197 546.487047c0 21.222798 15.917098 31.834197 31.834197 37.139896h143.253886c31.834197 0 26.528497-21.222798 26.528498-21.222798V450.984456c0-21.222798-15.917098-42.445596-37.139897-42.445596h726.880829z"
                transform="translate(-54.087 .358)"
                fill={(colors && colors.length && colors[1]) ? colors[1] : "#ccc"}/>
        </svg>
    ),

    //收藏
    collect: (colors) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1024" className="design-iconfont">
            <path
                d="M540.17121 0.004982a78.432483 78.432483 0 0 0-70.627981 42.675684L347.383391 291.096322l-281.128146 40.90445a77.159408 77.159408 0 0 0-62.214616 49.815974 71.956407 71.956407 0 0 0 18.155155 75.443525l206.016727 201.256534-47.767983 279.024805a72.897375 72.897375 0 0 0 31.992925 72.842024 81.255388 81.255388 0 0 0 44.945079 13.561015 82.36241 82.36241 0 0 0 37.749438-9.243631l245.094591-129.134074 245.149943 129.134074a81.476793 81.476793 0 0 0 82.639165-4.317384 72.952726 72.952726 0 0 0 31.992926-72.842024l-47.767984-279.080156 206.072078-201.256534a71.956407 71.956407 0 0 0 18.099804-75.443525 77.491515 77.491515 0 0 0-62.214616-49.815974l-281.128146-40.90445L610.854542 42.90207A78.321781 78.321781 0 0 0 540.226561 0.226386z"
                transform="translate(-54.087 .358)"
                fill={(colors && colors.length && colors[1]) ? colors[1] : "#ccc"}/>
        </svg>
    ),

    //分享
    share: (colors) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1199 1024" className="design-iconfont">
            <path
                d="M599.754556 703.985236H479.815456a536.27128 536.27128 0 0 0-477.866667 307.849597q-1.889735-25.924798-1.948789-51.849597C0 606.54579 268.519493 320.014764 599.754556 320.014764V0l599.754556 512-599.754556 512z"
                transform="translate(-54.087 .358)"
                fill={(colors && colors.length && colors[1]) ? colors[1] : "#ccc"}/>
        </svg>
    ),
}

export default function ArticleSvg({type, style, colors}) {
    let Svg;
    if(type && articleSvgList[type]){
        Svg = articleSvgList[type]
    }
    let size = style && style['size'] || 16;
    return (
        Svg?<Icon component={() => Svg(colors)} style={{width: size, height: size, ...style}}/>:<span></span>
    )
}